import Vue from 'vue'

import App from './App.vue'
import router from './router'
import store from './store'

import './plugins/util'
import './plugins/element.js'
// import './plugins/ws'
import './plugins/ajax'

Vue.config.productionTip = false

import ECharts from 'vue-echarts' // refers to components/ECharts.vue in webpack
import MultiMedia from './components/liquor/MultiMedia'

// import ECharts modules manually to reduce bundle size
import 'echarts/lib/chart/map'

import 'animate.css';


// register component to use
Vue.component('v-chart', ECharts)
Vue.component('multi-media', MultiMedia)
import Viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'
Vue.use(Viewer);
Viewer.setDefaults({ "navbar": false, "title": false, "toolbar": false, "url": 'data-source'});
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
